import { ADMIN_ITEMS_DATA, AdminItem } from '@features/admin/constants/admin-item.constant';
import { RoleFuseNavigationItem } from '@core/navigation/navigation-data';
import { PermissionsEnum } from '@shared/features/user/user-roles.interface';

export const ADMIN_NAVIGATION: RoleFuseNavigationItem[] = [
  {
    id: 'public',
    title: 'administrator',
    type: 'basic',
    icon: 'mat_outline:admin_panel_settings',
    link: `/admin/dashboard`,
    permissions: [PermissionsEnum.ADMIN, PermissionsEnum.SUPER_ADMIN],
  },
  {
    id: 'admin',
    title: 'applications',
    type: 'basic',
    icon: 'mat_outline:list_alt',
    link: '/application/applications',
    permissions: [PermissionsEnum.OPERATOR, PermissionsEnum.BRIGADE],
  },
  {
    id: 'admin',
    title: 'control.module',
    type: 'collapsable',
    icon: 'mat_outline:settings',
    permissions: [PermissionsEnum.ADMIN, PermissionsEnum.SUPER_ADMIN],
    children: [
      ADMIN_ITEMS_DATA[AdminItem.USER].navigation,
      ADMIN_ITEMS_DATA[AdminItem.WAREHOUSE].navigation,
      ADMIN_ITEMS_DATA[AdminItem.BRIGADE].navigation,
    ],
  },
  {
    id: 'admin',
    title: 'warehouse',
    type: 'collapsable',
    icon: 'mat_outline:home',
    permissions: [PermissionsEnum.WAREHOUSE_MANAGER],
    children: [
      ADMIN_ITEMS_DATA[AdminItem.PRODUCTS].navigation,
      ADMIN_ITEMS_DATA[AdminItem.COMPLEXES].navigation,
      ADMIN_ITEMS_DATA[AdminItem.DRONES].navigation,
      ADMIN_ITEMS_DATA[AdminItem.CARS].navigation,
      ADMIN_ITEMS_DATA[AdminItem.WAREHOUSE_REQUESTS].navigation,
    ],
  },
  {
    id: 'admin',
    title: 'brigade.requests',
    type: 'basic',
    icon: 'mat_outline:assignment',
    link: `/admin/dashboard/${AdminItem.BRIGADE_REQUESTS}`,
    permissions: [PermissionsEnum.WAREHOUSE_MANAGER, PermissionsEnum.BRIGADE],
  },
  {
    id: 'admin',
    title: 'RESOURCES',
    type: 'collapsable',
    icon: 'heroicons_outline:folder-open',
    permissions: [PermissionsEnum.RESOURCES],
    children: [ADMIN_ITEMS_DATA[AdminItem.TECHNIQUES].navigation],
  },
  {
    id: 'admin',
    title: 'directory',
    type: 'collapsable',
    icon: 'mat_outline:article',
    permissions: [PermissionsEnum.ADMIN, PermissionsEnum.SUPER_ADMIN],
    children: [
      ADMIN_ITEMS_DATA[AdminItem.ROLES].navigation,
      ADMIN_ITEMS_DATA[AdminItem.PRODUCT_TYPES].navigation,
      ADMIN_ITEMS_DATA[AdminItem.PRODUCT_TYPE_PARAMS].navigation,
      ADMIN_ITEMS_DATA[AdminItem.REGIONS].navigation,
      ADMIN_ITEMS_DATA[AdminItem.DISTRICTS].navigation,
    ],
  },
  {
    id: 'admin',
    title: 'organizations',
    type: 'collapsable',
    icon: 'mat_outline:home_work',
    permissions: [PermissionsEnum.SUPER_ADMIN],
    children: [ADMIN_ITEMS_DATA[AdminItem.ORGANIZATIONS].navigation],
  },
];
